import { render, staticRenderFns } from "./AddHotel.vue?vue&type=template&id=915f53f6"
import script from "./AddHotel.vue?vue&type=script&lang=js"
export * from "./AddHotel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports